import React, { useEffect, useCallback, useState} from 'react';
import Documented from 'components/help/Documented.js';
import {UNFREEZE_BUTTON} from 'constants/contextual-help.js';
import FrozenProgressComponent from 'components/freeze/FrozenProgressComponent.js';
import FrozenDragArea from 'components/freeze/FrozenDragArea.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {connect} from 'react-redux';

const TrackFrozenComponent = ({track, trackColor, isTrackFrozen, isFrozen}) => { 
    let {sequencerEngine} = track;
    let hasSamples = track.frozenColumns.some(
        x => x.frozenSamplers.length > 0);
    return  (
        <div className="frozen-columns-container">
          {track.frozenColumns.map
           ((col, i) => 
            <FrozenProgressComponent
              key={i}
              number={i}
              column={col}
              color={trackColor}
              sequencerEngine={sequencerEngine}
              track={track} />
           )}
          <div>
            {hasSamples ?
             <FrozenDragArea
               track={track}/> : ''}
            <ConditionedComponent condition={isFrozen}>
              <Documented element={UNFREEZE_BUTTON}>
                <div
                  style={
                      {
                          backgroundColor: trackColor
                      }
                  }
                  onClick={() => {
                      track.unfreeze();
                  }}
                  className="expand-sample">
                  Unfreeze
                </div>
              </Documented>
            </ConditionedComponent>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      isFrozen: props.track.isFrozen
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackFrozenComponent);
